module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_98_157.91505f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_98_157.jpg
// module id = Xvwo
// module chunks = 0